module.exports = __webpack_public_path__ + "media/pl_pl_s4_Lidia.e7dbaac5.oga";